import { Component, OnInit } from '@angular/core';
import { SharingDataService } from 'src/shared/services/sharingData/sharing-data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Card } from 'src/app/models/card.model';
import { ValidationService } from 'src/shared/services/validation/validation.service';
import { FormattingService } from 'src/shared/services/formatting/formatting.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-desired-credit-limit',
  templateUrl: './desired-credit-limit.component.html',
  styleUrls: ['./desired-credit-limit.component.css']
})
export class DesiredCreditLimitComponent implements OnInit {

  constructor(private sharingDataService: SharingDataService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private formattingService: FormattingService,
    private router: Router
  ) { }

  desiredCreditLimitFormGroup: FormGroup;
  selcetedCard: Card;
  submitted: boolean = false;

  ngOnInit(): void {
    this.selcetedCard = this.sharingDataService.minimumPaymtCalSharedData.SelectedCard;
    this.buildingForm(this.selcetedCard);
  }

  buildingForm(selcetedCard: Card) {
    this.desiredCreditLimitFormGroup = this.formBuilder.group({
      DesiredCreditLimitTxBx: ['', [Validators.required, this.validationService.DesiredCreditLimitValidation(selcetedCard.MinCreditLimit, selcetedCard.MaxCreditLimit,true)]]
    });
    this.desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.valueChanges.subscribe((change) => {
      let incomeVal = this.desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.value;
      let unwantedContentRemovedValue = incomeVal.replace(/[^0-9,.]/g, '');
      if (change != unwantedContentRemovedValue) {
        this.desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.setValue(unwantedContentRemovedValue);
      }
    });
  }
  calcuateBtnClick() {
    this.submitted = true;
    // stop here, if FormGroup is invalid
    if (this.desiredCreditLimitFormGroup.invalid) {
      return;
    }
    let desiredCreditLimit = this.desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.value
    this.sharingDataService.minimumPaymtCalSharedData.DesiredCreditLimit = desiredCreditLimit;
    this.router.navigate(['/cardinfo']);
  }
  desiredCreditLimitTxBx_Blur(event: any) {
    let value = event.target.value;
    let removeFormattedValue = this.formattingService.removeFormattedCurrency(value);
    let formattedValue = this.formattingService.formatCurrency(removeFormattedValue);
    this.desiredCreditLimitFormGroup.get('DesiredCreditLimitTxBx').setValue(formattedValue);
  }

}
